/* NOVAVICT.COM home page scripts.
   Lifted verbatim from the inline <script> on the novavict.de home page: scroll reveal,
   animated counters, FAQ accordion, countdown timer.

   WHY THIS FILE EXISTS: the home sections were ported from .de with neither their CSS nor
   their JS. nv-home.css defines .reveal{opacity:0}, and this is what adds .visible. Ship
   one without the other and every section below the header renders invisible — which is
   exactly what happened. Do not load the CSS without this file. */
(function () {
  // Safety net: if IntersectionObserver is missing or anything below throws, reveal
  // everything rather than leaving the page blank.
  function revealAll() {
    document.querySelectorAll('.reveal').forEach(function (el) { el.classList.add('visible'); });
  }
  if (!('IntersectionObserver' in window)) {
    document.addEventListener('DOMContentLoaded', revealAll);
    return;
  }
  window.addEventListener('error', function once() {
    window.removeEventListener('error', once);
    revealAll();
  });
})();

document.addEventListener('DOMContentLoaded', function () {
/* SCROLL REVEAL */
const revealThreshold = window.innerWidth < 900 ? 0.07 : 0.12;
const observer = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      entry.target.classList.add('visible');
      observer.unobserve(entry.target);
    }
  });
}, { threshold: revealThreshold });
document.querySelectorAll('.reveal').forEach(el => observer.observe(el));

/* ANIMATED COUNTERS */
function animateCount(el) {
  const target = parseInt(el.dataset.count, 10);
  const suffix = el.dataset.suffix || '';
  const duration = 1400;
  const start = performance.now();
  (function step(now) {
    const progress = Math.min((now - start) / duration, 1);
    const ease = 1 - Math.pow(1 - progress, 3);
    el.textContent = Math.round(target * ease).toLocaleString() + suffix;
    if (progress < 1) requestAnimationFrame(step);
  })(start);
}
const countObserver = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) { animateCount(entry.target); countObserver.unobserve(entry.target); }
  });
}, { threshold: 0.5 });
document.querySelectorAll('[data-count]').forEach(el => countObserver.observe(el));

/* FAQ ACCORDION */
document.querySelectorAll('.faq-btn').forEach(btn => {
  btn.addEventListener('click', () => {
    const item = btn.closest('.faq-item');
    const isOpen = item.classList.contains('open');
    document.querySelectorAll('.faq-item').forEach(i => i.classList.remove('open'));
    if (!isOpen) item.classList.add('open');
  });
});

/* COUNTDOWN TIMER */
(function() {
  const KEY = 'nv_timer_end';
  const DURATION = 59 * 60 + 58;
  let endTime = parseInt(sessionStorage.getItem(KEY) || '0', 10);
  if (!endTime || endTime <= Date.now()) {
    endTime = Date.now() + DURATION * 1000;
    sessionStorage.setItem(KEY, endTime);
  }

  const elH = document.getElementById('cd-h');
  const elM = document.getElementById('cd-m');
  const elS = document.getElementById('cd-s');
  if (!elH) return;

  function pad(n) { return String(n).padStart(2, '0'); }

  function flash(el, val) {
    el.classList.add('tick');
    setTimeout(() => { el.textContent = val; el.classList.remove('tick'); }, 120);
  }

  let lastH, lastM, lastS;

  function tick() {
    let remaining = Math.max(0, Math.round((endTime - Date.now()) / 1000));
    if (remaining === 0) {
      endTime = Date.now() + DURATION * 1000;
      sessionStorage.setItem(KEY, endTime);
      remaining = DURATION;
    }
    const h = Math.floor(remaining / 3600);
    const m = Math.floor((remaining % 3600) / 60);
    const s = remaining % 60;
    const pH = pad(h), pM = pad(m), pS = pad(s);
    if (pH !== lastH) { flash(elH, pH); lastH = pH; }
    if (pM !== lastM) { flash(elM, pM); lastM = pM; }
    if (pS !== lastS) { flash(elS, pS); lastS = pS; }
  }

  tick();
  setInterval(tick, 1000);
})();

/* MOBILE CAROUSELS */
function initCarousel(trackSel, navId, itemSel) {
  const track = document.querySelector(trackSel);
  const nav   = document.getElementById(navId);
  if (!track || !nav) return;
  const items = track.querySelectorAll(itemSel);
  if (!items.length) return;

  items.forEach((_, i) => {
    const dot = document.createElement('button');
    dot.className = 'carousel-dot' + (i === 0 ? ' active' : '');
    dot.setAttribute('aria-label', 'Zu Element ' + (i + 1) + ' wechseln');
    dot.addEventListener('click', () => {
      const gap = parseInt(getComputedStyle(track).gap) || 16;
      track.scrollTo({ left: items[i].offsetLeft - 24, behavior: 'smooth' });
    });
    nav.appendChild(dot);
  });

  track.addEventListener('scroll', () => {
    const dots = nav.querySelectorAll('.carousel-dot');
    const midX = track.scrollLeft + track.clientWidth / 2;
    let closest = 0, minDist = Infinity;
    items.forEach((item, i) => {
      const itemMid = item.offsetLeft + item.offsetWidth / 2;
      const dist = Math.abs(midX - itemMid);
      if (dist < minDist) { minDist = dist; closest = i; }
    });
    dots.forEach((d, i) => d.classList.toggle('active', i === closest));
  }, { passive: true });
}

initCarousel('.ingredient-cards', 'ing-nav', '.ing-card');
initCarousel('.testi-grid', 'testi-nav', '.tcard');

document.querySelectorAll('.scroll-top').forEach(btn => {
  btn.addEventListener('click', () => window.scrollTo({ top: 0, behavior: 'smooth' }));
});
});
